import { Component, OnInit } from '@angular/core';
import {GLOBAL} from "../../services/GLOBAL";

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.css']
})
export class AboutComponent implements OnInit {

  public global = GLOBAL;

  constructor() { }

  ngOnInit(): void {
  }

}
